// extracted by mini-css-extract-plugin
export default {"root":"BlockFooterBrand_root__qpLGZ","logo":"BlockFooterBrand_logo__sqmOp","icons":"BlockFooterBrand_icons__5wg0E"};